module.exports = __webpack_public_path__ + "img/ni.b8755cbb.svg";